module.exports = __webpack_public_path__ + "static/media/header-background.6ade0228.png";